/**
 * Field — labelled input wrapper matching the brandbook.
 *
 * Mockup classes: .field (label + input vertical stack), .input,
 * .select, .textarea (consistent focus + sizing).
 */

import type {
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  id?: string;
}

export function Field({ label, hint, error, children, id }: FieldProps) {
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      {children}
      {hint && <div className="t-xs">{hint}</div>}
      {error && (
        <div role="alert" className="t-xs t-danger">
          {error}
        </div>
      )}
    </div>
  );
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`input ${props.className ?? ""}`} />;
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={`select ${props.className ?? ""}`} />;
}

export function Textarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea {...props} className={`textarea ${props.className ?? ""}`} />
  );
}
